import React, { useState, useEffect } from 'react';
import axios from 'axios';

const FavoriteButton = ({ articleId, storyType, authUser }) => {
  const [isFavorited, setIsFavorited] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (authUser && articleId) {
      checkFavoriteStatus();
    }
  }, [authUser, articleId, storyType]);

  const checkFavoriteStatus = async () => {
    try {
      const response = await axios.get(`/api/favorites/check/${articleId}/${storyType}`);
      setIsFavorited(response.data.is_favorited);
    } catch (error) {
      console.error('Error checking favorite status:', error);
    }
  };

  const toggleFavorite = async () => {
    if (!authUser || loading) return;

    setLoading(true);
    try {
      if (isFavorited) {
        await axios.delete(`/api/favorites/${articleId}/${storyType}`);
        setIsFavorited(false);
      } else {
        await axios.post('/api/favorites', {
          article_id: articleId,
          story_type: storyType
        });
        setIsFavorited(true);
      }
    } catch (error) {
      console.error('Error toggling favorite:', error);
    } finally {
      setLoading(false);
    }
  };

  if (!authUser) {
    return null; // Don't show favorite button for non-authenticated users
  }

  return (
    <button
      className={`btn favorite-button-pin ${isFavorited ? 'favorited' : ''}`}
      onClick={(e) => {
        e.stopPropagation();
        toggleFavorite();
      }}
      disabled={loading}
      title={isFavorited ? 'Remove from favorites' : 'Add to favorites'}
      style={{ 
        background: 'none', 
        border: 'none', 
        padding: '6px 10px',
        color: isFavorited ? '#ffc107' : '#6c757d',
        fontSize: '1.1rem'
      }}
    >
      {loading ? (
        <span className="spinner-border spinner-border-sm" role="status"></span>
      ) : (
        <i className={`fas fa-thumbtack`}></i>
      )}
    </button>
  );
};

export default FavoriteButton;
